import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { ThemeProvider } from '@mui/styles'

import Quiz from './pages/Quiz'
import Home from './pages/Home'
import Results from './pages/Results'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'

import theme from './utils/theme'
import AlmostFinished from './pages/AlmostFinished'
// https://material-ui.com/customization/theming/
// https://material-ui.com/customization/color/

const App = React.memo(() => {
  // console.log('App reloaded') // only happening twice

  // React.useEffect(() => {
  // Load question images in the background
  // const load_question = async (question_index: number) => {
  //   questions_list[question_index].options
  //     .map((o) => optionsDict[o].content)
  //     .forEach((image) => (new Image().src = image))
  // }
  // load_question(1)
  //   .then(() => load_question(2))
  //   .then(() => load_question(3))
  //   .then(() => load_question(4))
  //   .then(() => load_question(5))
  //   .then(() => load_question(6))
  // }, [])

  return (
    <ThemeProvider theme={theme}>
      <div className='App'>
        <Header />
        <div className='App-body'>
          <Switch>
            <Route path='/quiz'>
              <Quiz />
            </Route>
            <Route path='/style-results/'>
              <Results />
            </Route>
            <Route path='/almost-finished/'>
              <AlmostFinished />
            </Route>
            <Route path='/'>
              <Home />
            </Route>
          </Switch>
        </div>
      </div>
      <Footer />
    </ThemeProvider>
  )
})

export default App
